import axiosPackage from 'axios';
export let axios;

export const setUrlAssoluto = (initialData) => {
	//console.log(initialData);
	axios = axiosPackage.create({
		baseURL: initialData['URLASSOLUTOVARIABLE'],
	});

	return axios;
};
